import { useContext } from 'react';

import { AlertContext } from './AlertContext';
import { AuthenticationContext } from './AuthenticationContext';
import { PermissionsContext } from './PermissionsContext';
import { SidebarContext } from './SidebarContext';

const useAuthentication = () => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error(
      'useAuthentication must be used within an AuthenticationProvider',
    );
  }
  return context;
};
const usePermissions = () => useContext(PermissionsContext);
const useSidebar = () => useContext(SidebarContext);
const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export { useAlert, useAuthentication, usePermissions, useSidebar };
